import React from 'react';
import loadable, { LoadableComponent } from '@loadable/component';
import { StatusCodes } from 'http-status-codes';
import { StatusCodeProvider } from '../hooks/useStatusCode';
import { ErrorBoundary } from '../components/ErrorBoundary';
import { Loading } from '../components/Loading';

const ErrorScreen = loadable(() => import('../components/ErrorScreen'), {
  fallback: <Loading />
});

// eslint-disable-next-line @typescript-eslint/ban-types
export const renderWithStatusCode = <TProps extends {}>(
  Component: React.FC | LoadableComponent<TProps>,
  statusCode?: number
) => ({ staticContext, ...rest }: { staticContext: { statusCode: number } }) => {
  if (staticContext) {
    staticContext.statusCode = statusCode || StatusCodes.OK;
  }

  return (
    <ErrorBoundary FallbackComponent={ErrorScreen}>
      <StatusCodeProvider value={staticContext ?? { statusCode: StatusCodes.OK }}>
        <Component {...(rest as TProps)} />
      </StatusCodeProvider>
    </ErrorBoundary>
  );
};
